<template>
    <div class="row left-content">
        <b-card
            v-if="clients"
            title="Clients"
        >
            <div>
                <b-form inline>
                    <b-form-input
                        v-model="form.id"
                        type="text"
                        placeholder="ID"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.firstName"
                        type="text"
                        placeholder="First Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.lastName"
                        type="text"
                        placeholder="Last Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder="Email"
                    ></b-form-input>

                    <b-button variant="primary" type="submit" @click.prevent.stop="search">Search</b-button>
                </b-form>
            </div>
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Created At</th>
                    <th>Name</th>
                    <th>Type</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="client in clients" :key="client.id">
                    <td>
                        <router-link :to="{name: 'admin.project_wallet.client.view', params: { id: client.id }}">
                            {{ client.id }}
                        </router-link>
                    </td>
                    <td>{{ formatedDate(client.date) }}</td>
                    <td>{{ client.name + '(' + client.email + ')' }}</td>
                    <td>
                        <b-badge class="mr-1" variant="primary" v-if="client.has_payment_customer_id">Demand</b-badge>
                        <b-badge variant="success" v-if="client.has_transfer_customer_id">Supplier</b-badge>
                    </td>
                </tr>
                </tbody>
            </table>
            <b-pagination
                v-if="paginator.total / paginator.perPage > 1"
                :value="page"
                :total-rows="paginator.total"
                :per-page="paginator.perPage"
                @change="change($event)"
            ></b-pagination>
        </b-card>

    </div>
</template>

<script>
import {UrlMixin} from "@/views/admin/Wallet/ProjectWallet/UrlMixin";

export default {
    name: "List",
    props: {
        'page': {
            'default': 1
        }
    },
    mixins: [UrlMixin],
    data() {
        return {
            clients: [],
            paginator: [],
            form: {
                email: null,
                firstName: null,
                lastName: null,
                id: null
            }
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.$router.push({ name: 'admin.project_wallet.client', params: { page: event }, query: { form: this.form } });
        },
        getClients(page) {
            window.axios.get(this.getUrl('/admin/wallet/project/client/index'), {params: {...{page: page}, ...this.form}})
                .then(response => {
                        this.clients = response.data.clients;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
        search() {
            this.getClients(this.page);
        }
    },
    mounted() {
        if (this.$router.currentRoute.query.form !== undefined) {
            this.form = this.$router.currentRoute.query.form;
        }
        this.getClients(this.page);
    }
}
</script>